export const tracking = (action: string) => {
  window._satellite?.track(action);
};
